import api from '../../utils/apiFetch';

const path = 'merchants';

export default {
  getRegistration: (payload) =>
    api.get(`${path}/unverified?${api.serialize(payload)}`),
  getAllMerchantApi: (payload) =>
    api.get(`${path}/registered?${api.serialize(payload)}`),
  updateUnverifiedMerchant(payload) {
    return api.post(`${path}/unverified`, payload);
  },
  createSquareCustomer(payload) {
    return api.post(`${path}/square-customer`, payload);
  },
  getMerchantAdmins: (businessId, payload) =>
    api.get(`${path}/${businessId}/admins?${api.serialize(payload)}`),
  updateMerchantAdmin(payload) {
    return api.put(`${path}/admin`, payload);
  },
  deleteMerchantAdmin(id) {
    return api.deleteRequest(`${path}/admin/${id}`);
  },
};
